export default __webpack_public_path__ + "static/media/googlescholar.1fd271fa.svg";